import { AdFileSize } from '@ligr/api-v2';
export const adSizes = {
    [AdFileSize.small]: { width: 300, height: 70, weight: 0.3 },
    [AdFileSize.medium]: { width: 912, height: 70, weight: 0.5 },
    [AdFileSize.large]: { width: 1920, height: 270, weight: 0.65 },
    [AdFileSize.long]: { width: 1920, height: 140, weight: 0.4 },
    [AdFileSize.xLarge]: { width: 1920, height: 410, weight: 0.7 },
    [AdFileSize.banner]: { width: 510, height: 150, weight: 0.4 },
    [AdFileSize.square]: { weight: 0.35, height: 250, width: 250 }
};
//# sourceMappingURL=ads.js.map